import { createSelector } from '@reduxjs/toolkit';

import type { RouteParamsAppState } from '../../../../ducks/route_params/types';
import type { TreeAppState } from '../../../../ducks/tree/types';
import { hasSharedCollectionTreeChildren } from '../../../../panels/collections/utils';
import type { AppState } from '../../../../store/types';
import { getShareCollectionsPanelItem } from '../common';

const getRouteParams = (state: AppState): RouteParamsAppState =>
  state.routeParams;
const getTree = (state: AppState): TreeAppState => state.collectionsTree;

export default createSelector(getTree, getRouteParams, (tree, routeParams) => {
  const panels = [];
  if (
    hasSharedCollectionTreeChildren(
      tree.treeModel.treeRoot,
      routeParams.query.object_id,
    )
  ) {
    panels.push(
      getShareCollectionsPanelItem(routeParams.query.object_id, true),
    );
  }

  return panels;
});
